import React, { useContext, useState } from "react";

import { NotesFirstStep } from "./NotesFirstStep";
import { NotesSecondStep } from "./NotesSecondStep";
import { AutoRegistrationContext } from "../../context/AutoRegistrationProvider";

export const ExchangeNotes = () => {
  const [stepNotes, setStepNotes] = useState(0);
  const { data } = useContext(AutoRegistrationContext);

  const isTransporterData = data?.usertype === "transporter";

  return (
    <>
      {stepNotes === 0 && <NotesFirstStep changeStep={setStepNotes} />}
      {stepNotes === 1 && (
        <NotesSecondStep
          isTransporter={isTransporterData}
          changeStep={setStepNotes}
        />
      )}
    </>
  );
};
